import React, {useState, useEffect} from 'react';
import Divider from '../Divider';


// @ts-ignore
const getTranslateX = (scrollPosition, start, end, initialX, finalX, scrollRange) => {
    const scrollPercent = scrollPosition / scrollRange;
    if (scrollPercent < start) return initialX;
    if (scrollPercent > end) return finalX;
    return initialX + (finalX - initialX) * (scrollPercent - start) / (end - start);
};

// @ts-ignore
const getTranslateY = (scrollPosition, start, end, initialY, finalY, scrollRange) => {
    const scrollPercent = scrollPosition / scrollRange;
    if (scrollPercent < start) return initialY;
    if (scrollPercent > end) return finalY;
    return initialY + (finalY - initialY) * (scrollPercent - start) / (end - start);
};

// @ts-ignore
const getScale = (scrollPosition, start, end, initialScale, finalScale, scrollRange) => {
    const scrollPercent = scrollPosition / scrollRange;
    if (scrollPercent < start) return initialScale;
    if (scrollPercent > end) return finalScale;
    return initialScale + (finalScale - initialScale) * (scrollPercent - start) / (end - start);
};


const ProductsExampleSection = () => {
    const [scrollPosition, setScrollPosition] = useState(0);
    const [scrollRange, setScrollRange] = useState(window.innerHeight * 1.5); // Default scrollRange

    useEffect(() => {
        const handleScroll = () => {
            setScrollPosition(window.scrollY);
        };

        const handleResize = () => {
            // Adjust scrollRange based on screen size
            if (window.innerWidth >= 1920) { // Example: Big monitor breakpoint
                setScrollRange(window.innerHeight * 1.5);
            } else if (window.innerWidth >= 1280) { // Example: Desktop breakpoint
                setScrollRange(window.innerHeight * 1.2); // Example: Laptop breakpoint
            } else {
                setScrollRange(window.innerHeight / 1.1); // Example: Mobile breakpoint
            }
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize); // Listen for resize
        handleResize(); // Set initial scrollRange
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    return (
        <section
            className=" sm:h-[65vh] h-[75vh] md:h-[86vh] lg:h-[70vh] xl:h-[90vh] max-h-screen w-full relative ">
            <Divider/>
            <div className={"relative m-auto w-full h-full max-w-2xl"}>
                <img
                    className="absolute"
                    src="https://storage.googleapis.com/lesia-k/Pictures/Illustration1.png"
                    alt=""
                    loading="eager"
                    style={{
                        transform: `translate(${getTranslateX(scrollPosition, 0, 0.5, -900, 0, scrollRange)}px, ${getTranslateY(scrollPosition, 0, 0.5, -50, 100, scrollRange)}px) scale(${getScale(scrollPosition, 0, 0.5, 0, 1, scrollRange)})`,
                    }}
                />
                <img
                    className="absolute"
                    src="https://storage.googleapis.com/lesia-k/Pictures/Illustration2.png"
                    alt=""
                    loading="eager"
                    style={{
                        transform: `translate(${getTranslateX(scrollPosition, 0, 0.5, -100, 0, scrollRange)}px, ${getTranslateY(scrollPosition, 0, 0.5, 50, 100, scrollRange)}px) scale(${getScale(scrollPosition, 0, 0.5, 0.8, 1, scrollRange)})`,
                    }}
                />
                <img
                    className="absolute"
                    src="https://storage.googleapis.com/lesia-k/Pictures/Illustration3.png"
                    alt=""
                    loading="eager"
                    style={{
                        transform: `translate(${getTranslateX(scrollPosition, 0.2, 0.7, 200, 0, scrollRange)}px, ${getTranslateY(scrollPosition, 0.2, 0.7, -150, 100, scrollRange)}px) scale(${getScale(scrollPosition, 0.2, 0.7, 0.7, 1, scrollRange)})`,
                    }}
                />
                <img
                    className="absolute"
                    src="https://storage.googleapis.com/lesia-k/Pictures/Illustration4.png"
                    alt=""
                    loading="eager"
                    style={{
                        transform: `translate(${getTranslateX(scrollPosition, 0.4, 0.9, -300, 0, scrollRange)}px, ${getTranslateY(scrollPosition, 0.4, 0.9, 50, 100, scrollRange)}px) scale(${getScale(scrollPosition, 0.4, 0.9, 0.6, 1, scrollRange)})`,
                    }}
                />
                <img
                    className="absolute top-0  md:left-0 hover:scale-105"
                    src="https://storage.googleapis.com/lesia-k/Pictures/Illustration5.png"
                    alt=""
                    loading="eager"
                    style={{
                        transform: `translate(${getTranslateX(scrollPosition, 0.1, 0.8, 100, 0, scrollRange)}px, ${getTranslateY(scrollPosition, 0.1, 1, -80, 100, scrollRange)}px) scale(${getScale(scrollPosition, 0.8, 1, 0.8, 1, scrollRange)})`,
                    }}
                />
                <img
                    className="absolute z-20"
                    src="https://storage.googleapis.com/lesia-k/Pictures/Illustration6.png"
                    alt=""
                    loading="eager"
                    style={{
                        transform: `translate(${getTranslateX(scrollPosition, 0.5, 0.7, -250, 0, scrollRange)}px, ${getTranslateY(scrollPosition, 0.8, 1, 120, 80, scrollRange)}px) scale(${getScale(scrollPosition, 0.2, 0.9, 0.7, 1, scrollRange)})`,
                    }}
                />
                <div className="absolute bottom-0 w-full h-[3vh] z-10 bg-gray-900"></div>
            </div>

        </section>
    );
};

export default ProductsExampleSection;
